export default __webpack_public_path__ + "static/image-45-beb274fb702aa2ab2d60c2a3073a6769.png";